<template lang="pug">
  .final
    Frame(:mod="isLicense ? 'small-pad' : 'big'")
      img.final__image(src="/static/img/final__image.png")
      .final__title Вы набрали
        span.final__points  {{ points }}&nbsp;очков!
      p.final__text(v-html="currentText")
      Buttons(:type="currentButtons", :position="isLicense ? '' : 'relative'", @reset="() => $emit('reset')")
</template>

<script>
import { mapGetters } from 'vuex';
import Frame from '@/components/UI/Frame';
import Share from '@/components/UI/Share';
import Buttons from '@/components/UI/Buttons';

export default {
  name: 'Final',
  components: { Frame, Share, Buttons },
  props: ['points'],
  computed: {
    ...mapGetters(['isLicense']),
    currentText() {
      return this.items.find(item => item.license === this.isLicense).text;
    },
    currentButtons() {
      return this.isLicense ? 'enter' : 'play';
    },
  },
  data() {
    return {
      items: [
        {
          license: true,
          text: '<b>Бобр Мороз доволен!<br/>Попробуйте набрать еще больше<br/>баллов в следующем заезде</b>',
        },
        {
          license: false,
          text: '<b>Отличная гонка!</b> <br/>Попробуйте набрать еще&nbsp;больше баллов в следующем заезде',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
  $image-width: 313px;

  .final {
    z-index: z('header');
    position: relative;
    &__title {
      @include typo-h1;
      color: $clr-hoverMain;
      margin: 67px 0 0;
      width: 100%;
    }
    &__text {
      @include typo-text;
      color: $clr-blue;
      margin: 19px 0 20px;
      @media (max-width: $max-width-xs) {
        @include typo-p(normal);
        margin: 14px 0 20px;
      }
    }
    &__points {
      color: $clr-hoverMain;
      white-space: nowrap;
    }
    &__share {
      margin: 0 0 30px;
      @media (max-width: $max-width-xs) {
        margin: 0 0 60px;
      }
      &_bottom {
        order: 1;
        margin: 15px 0 0;
      }
    }
    &__image {
      @media (max-width: $max-width-xs) {
        display: block;
        width: 100%;
        max-width: $image-width;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/Final.vue